(function () {
  'use strict';

  function initB2bStickyCta() {
    var sticky = document.querySelector('[data-nuvra-b2b-sticky]');
    var quote = document.querySelector('[data-nuvra-b2b-quote]');
    if (!sticky || !quote) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.classList.remove('is-visible');
          } else {
            sticky.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.05 }
    );

    observer.observe(quote);
  }

  function initB2bFaq() {
    document.querySelectorAll('[data-nuvra-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-nuvra-faq-item]');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('[data-nuvra-faq-item]').forEach(function (el) {
          el.classList.remove('is-open');
        });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  function initB2bSmoothScroll() {
    document.querySelectorAll('[data-nuvra-scroll-quote]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector('[data-nuvra-b2b-quote]');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initB2bStickyCta();
      initB2bFaq();
      initB2bSmoothScroll();
    });
  } else {
    initB2bStickyCta();
    initB2bFaq();
    initB2bSmoothScroll();
  }
})();
